import React from 'react'
import { createThemeIcon } from '../../helper/createThemeIcon'
import { ReactComponent as BellDefault } from './bell.svg'
import { ReactComponent as BellBIDV } from './BIDV/bell.svg'
import { ReactComponent as ArrowLeftDefault } from './ArrowLeft.svg'
import { ReactComponent as ArrowLeftBIDV } from './BIDV/ArrowLeft.svg'
import { ReactComponent as ArrowRightDefault } from './arrow_right.svg'
import { ReactComponent as ArrowRightBIDV } from './BIDV/arrow_right.svg'
import { ReactComponent as CardLinkSupportPunishDefault } from './card_link_support_punish.svg'
import { ReactComponent as CardLinkSupportQuestionDefault } from './card_link_support_question.svg'
import { ReactComponent as CardLinkSupportServiceDefault } from './card_link_support_service.svg'
import { ReactComponent as CardLinkSupportPunishBIDV } from './BIDV/card_link_support_punish.svg'
import { ReactComponent as CardLinkSupportQuestionBIDV } from './BIDV/card_link_support_question.svg'
import { ReactComponent as CardLinkSupportServiceBIDV } from './BIDV/card_link_support_service.svg'
import { ReactComponent as AutomatedTrafficFineNotificationStep1Default } from './AutomatedTrafficFineNotificationStep1.svg'
import { ReactComponent as AutomatedTrafficFineNotificationStep1BIDV } from './BIDV/AutomatedTrafficFineNotificationStep1.svg'
import { ReactComponent as AutomatedTrafficFineNotificationStep2Default } from './AutomatedTrafficFineNotificationStep2.svg'
import { ReactComponent as AutomatedTrafficFineNotificationStep2BIDV } from './BIDV/AutomatedTrafficFineNotificationStep2.svg'
import { ReactComponent as AutomatedTrafficFineNotificationStep3Default } from './AutomatedTrafficFineNotificationStep3.svg'
import { ReactComponent as AutomatedTrafficFineNotificationStep3BIDV } from './BIDV/AutomatedTrafficFineNotificationStep3.svg'
import { ReactComponent as AutomatedTrafficFineNotificationServicesTypeDefault } from './AutomatedTrafficFineNotificationServicesType.svg'
import { ReactComponent as AutomatedTrafficFineNotificationServicesTypeBIDV } from './BIDV/AutomatedTrafficFineNotificationServicesType.svg'
import { ReactComponent as AutomatedTrafficFineNotificationServicesMoneyDefault } from './AutomatedTrafficFineNotificationServicesMoney.svg'
import { ReactComponent as AutomatedTrafficFineNotificationServicesMoneyBIDV } from './BIDV/AutomatedTrafficFineNotificationServicesMoney.svg'






export const IconArrowLeft = createThemeIcon({
  default: ArrowLeftDefault,
  BIDV: ArrowLeftBIDV
})

export const IconAutomatedTrafficFineNotificationStep1 = createThemeIcon({
  default: AutomatedTrafficFineNotificationStep1Default,
  BIDV: AutomatedTrafficFineNotificationStep1BIDV
})


export const IconAutomatedTrafficFineNotificationStep2 = createThemeIcon({
  default: AutomatedTrafficFineNotificationStep2Default,
  BIDV: AutomatedTrafficFineNotificationStep2BIDV
})


export const IconAutomatedTrafficFineNotificationStep3 = createThemeIcon({
  default: AutomatedTrafficFineNotificationStep3Default,
  BIDV: AutomatedTrafficFineNotificationStep3BIDV
})


export const IconAutomatedTrafficFineNotificationServicesType = createThemeIcon({
  default: AutomatedTrafficFineNotificationServicesTypeDefault,
  BIDV: AutomatedTrafficFineNotificationServicesTypeBIDV
})


export const IconAutomatedTrafficFineNotificationServicesMoney = createThemeIcon({
  default: AutomatedTrafficFineNotificationServicesMoneyDefault,
  BIDV: AutomatedTrafficFineNotificationServicesMoneyBIDV
})
export { ReactComponent as IconAutomatedTrafficFineNotificationServicesSelected } from './AutomatedTrafficFineNotificationServicesSelected.svg'
export { ReactComponent as IconAutomatedTrafficFineNotificationIntroduce1 } from './AutomatedTrafficFineNotificationIntroduce1.svg'
export { ReactComponent as IconAutomatedTrafficFineNotificationIntroduce2 } from './AutomatedTrafficFineNotificationIntroduce2.svg'
export { ReactComponent as IconAutomatedTrafficFineNotificationIntroduce3 } from './AutomatedTrafficFineNotificationIntroduce3.svg'
export { ReactComponent as IconAutomatedTrafficFineNotificationIntroduce4 } from './AutomatedTrafficFineNotificationIntroduce4.svg'
export { ReactComponent as IconAutomatedTrafficFineNotificationIntroduce5 } from './AutomatedTrafficFineNotificationIntroduce5.svg'
export { ReactComponent as IconAutomatedTrafficFineNotificationIntroduce6 } from './AutomatedTrafficFineNotificationIntroduce6.svg'
export { ReactComponent as AutomatedTrafficFineNotificationVehiclesDelete } from './AutomatedTrafficFineNotificationVehiclesDelete.svg'
export { ReactComponent as AutomatedTrafficFineNotificationVehiclesSelected } from './AutomatedTrafficFineNotificationVehiclesSelected.svg'
export { ReactComponent as AutomatedTrafficFineNotificationAuthenticationHideInfo } from './AutomatedTrafficFineNotificationAuthenticationHideInfo.svg'
export { ReactComponent as AutomatedTrafficFineNotificationAuthenticationShowInfo } from './AutomatedTrafficFineNotificationAuthenticationShowInfo.svg'
export { ReactComponent as AutomatedTrafficFineNotificationVehiclesNotify } from './AutomatedTrafficFineNotificationVehiclesNotify.svg'
export { ReactComponent as IconTaxCDSNotificationStep2 } from './TaxCDSNotificationStep2.svg'
export { ReactComponent as IconCloseCircle } from './close_circle.svg'
export const IconArrowRight = createThemeIcon({
  default: ArrowRightDefault,
  BIDV: ArrowRightBIDV
})
export { ReactComponent as IconGreenCheck } from './green_check.svg'
export const IconCardLinkSupportPunish = createThemeIcon({
  default: CardLinkSupportPunishDefault,
  BIDV: CardLinkSupportPunishBIDV
})

export const IconCardLinkSupportQuestion = createThemeIcon({
  default: CardLinkSupportQuestionDefault,
  BIDV: CardLinkSupportQuestionBIDV
})

export const IconCardLinkSupportService = createThemeIcon({
  default: CardLinkSupportServiceDefault,
  BIDV: CardLinkSupportServiceBIDV
})
export { ReactComponent as IconNopPhatNguoi } from './nopPhatNguoi_circle_brand.svg'
export { ReactComponent as IconClose } from './close.svg'
export { ReactComponent as IconPhoneCircleBrand } from './phone_circle_brand.svg'
export { ReactComponent as IconPhoneCallStroke } from './phone_call_stroke.svg'

export { ReactComponent as IconCheckCircleGreen } from './check_circle_green.svg'
export { ReactComponent as IconArrowDown } from './arrow_down.svg'

export { ReactComponent as IconBidvBell } from './BIDV/bell.svg'

export const IconBell = createThemeIcon({
  default: BellDefault,
  BIDV: BellBIDV
})
